import React from 'react';
import { Box, Typography } from '@mui/material';
import { BRAND } from '../../theme/brandTokens';

const PageHeader = ({
  containerId,
  titleId,
  subtitleId,
  pageTitle,
  pageSubtitle,
  leadingContent,
  sx,
  mb = 4,
}) => {
  if (!pageTitle && !pageSubtitle && !leadingContent) {
    return null;
  }

  return (
    <Box
      id={containerId}
      sx={{
        textAlign: 'center',
        mb,
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        ...sx,
      }}
    >
      {leadingContent}
      {pageTitle && (
        <Typography
          id={titleId}
          component="h1"
          variant="h3"
          sx={{
            color: BRAND.onPrimary,
            fontWeight: 700,
            letterSpacing: '-0.03em',
            fontSize: { xs: '2.1rem', sm: '2.5rem', md: '2.75rem' },
            lineHeight: { xs: 1.05, sm: 1.1, md: 1.15 },
            mb: 1,
            px: { xs: 1, sm: 0 },
            maxWidth: '100%',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          }}
        >
          {pageTitle}
        </Typography>
      )}
      {pageSubtitle && (
        <Typography
          id={subtitleId}
          variant="h6"
          sx={{
            color: BRAND.onPrimaryMuted,
            fontWeight: 400,
            fontSize: { xs: '0.95rem', sm: '1.05rem', md: '1.25rem' },
            lineHeight: { xs: 1.45, sm: 1.5, md: 1.4 },
            maxWidth: 'min(42rem, 100%)',
            mx: 'auto',
            px: { xs: 1.5, sm: 0 },
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          }}
        >
          {pageSubtitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageHeader;
